import { AllSelectOption } from '@storage/app/models'

export const mapOptionalFieldValueToNumber = (
  value: string | AllSelectOption,
): number | undefined => {
  return !value || value === 'All' || isNaN(Number(value)) ? undefined : Number(value)
}
